$(document).ready(function () {
	$('.js-landing-scroll').on('click', function (){ 
        $('html, body').animate({
            scrollTop: $("#section05").offset().top
        }, 500);
	})
})